import {useEffect, useMemo} from 'react';

import {zodResolver} from '@hookform/resolvers/zod';
import {useForm} from 'react-hook-form';

import {buildDefaultValue, serializeParameters} from './domain';
import {createParametersSchema} from './schema';

export const useParametersForm = (parameters, updateDatasetParameters) => {
  const schema = useMemo(() => createParametersSchema(parameters), [parameters]);

  const defaultValues = useMemo(() => {
    const values = Object.fromEntries(parameters.map(p => [p.name, buildDefaultValue(p)]));

    return {parameters: values};
  }, [parameters]);

  const methods = useForm({
    resolver: zodResolver(schema),
    defaultValues,
    mode: 'all',
    shouldUnregister: false
  });

  const {handleSubmit, reset, formState} = methods;

  useEffect(() => {
    if (!parameters.length) return;
    reset(defaultValues);
  }, [parameters, defaultValues, reset]);

  const handleCancel = () => reset(defaultValues);

  const handleSubmitForm = handleSubmit(async values => {
    const changedParameters = Object.entries(values.parameters).filter(([key]) => formState.dirtyFields.parameters?.[key]);

    console.log({dirtyFields: formState.dirtyFields});

    const serialized = serializeParameters(Object.fromEntries(changedParameters), parameters);
    const res = await updateDatasetParameters(serialized);

    if (res.success) {
      reset(values);
    }
  });

  return {
    methods,
    formState,
    handleCancel,
    handleSubmitForm
  };
};
